module.exports = __webpack_public_path__ + "media/form-type-page/user-chart-8c83ef5a.svg";